// extracted by mini-css-extract-plugin
export var popper = "styles-module__popper___jPfa_";